<template>
    <div class="success-box">
        <div class="icon">
            <span><font-awesome-icon icon="check-square"/></span>
        </div>
        <div class="content">
            <h4>Excelente elección! Estás a 1 minuto de completar tu reserva. </h4>
            <p>Rellena los siguientes formularios para completarla </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "successBox"
    }
</script>

<style scoped>

</style>